import { render } from "./Tabs.vue?vue&type=template&id=1c419153&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"

import "./Tabs.vue?vue&type=style&index=0&id=1c419153&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c419153"],['__file',"src/components/mdbvue/Components/Tabs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1c419153"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1c419153', __exports__)) {
    api.reload('1c419153', __exports__)
  }
  
  module.hot.accept("./Tabs.vue?vue&type=template&id=1c419153&scoped=true", () => {
    api.rerender('1c419153', render)
  })

}


export default __exports__